// extracted by mini-css-extract-plugin
module.exports = {"sidenav":"sidebar-module__sidenav___1n7E9"};